import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import { TablePagination } from '@material-ui/core';
import ToggleBtn from 'ui/components/toggle-button';
import DropDown from '../ui/react-ui/dropdown';
import DataTable from '../ui/table';
import SearchBar from '../ui/searchBar';
import BillboardViewDetail from './billboardView-detail'; // api

import { getBillboardMessageList, getBillboardTypeList } from '../../api/settingAPI';
import { setBillboardTypeList } from '../../redux/app';
var t = i18n.getFixedT(null, 'board-billboardView');
var gt = i18n.getFixedT(null, 'app');

var BillboardView = function BillboardView(props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      billboardTypeList = _useSelector.app.billboardTypeList;

  var dispatch = useDispatch();
  var id = props.id;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      curTypeId = _useState2[0],
      setCurTypeId = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      totalCount = _useState4[0],
      setTotalCount = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      currentPage = _useState6[0],
      setCurrentPage = _useState6[1];

  var _useState7 = useState(10),
      _useState8 = _slicedToArray(_useState7, 2),
      rowsPerPage = _useState8[0],
      setRowsPerPage = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      keyword = _useState10[0],
      setKeyword = _useState10[1];

  var _useState11 = useState({}),
      _useState12 = _slicedToArray(_useState11, 2),
      tableData = _useState12[0],
      setTableData = _useState12[1];

  var _useState13 = useState({
    field: 'beginTime',
    desc: true
  }),
      _useState14 = _slicedToArray(_useState13, 2),
      tableSort = _useState14[0],
      setTableSort = _useState14[1];

  var _useState15 = useState({}),
      _useState16 = _slicedToArray(_useState15, 2),
      detailData = _useState16[0],
      setDetailData = _useState16[1];

  var fetchBillboardTypesRef = useRef(false);

  var handleOpenDialog = function handleOpenDialog() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    setDetailData(data);
  };

  var handleCloseDialog = function handleCloseDialog(act) {
    setDetailData({});
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var fetchBillboardList = function fetchBillboardList() {
    var offset = (Number(currentPage + 1) - 1) * rowsPerPage;
    getBillboardMessageList(contextRoot, false, keyword, tableSort, offset, rowsPerPage, curTypeId).then(function (result) {
      if (result.totalElements !== totalCount) setTotalCount(result.totalElements);

      var newData = _.cloneDeep(result.content);

      _.map(newData, function (el, index) {
        el.sequence = offset + index + 1;
      });

      setTableData(newData);
    });
  };

  useEffect(function () {
    fetchBillboardList();
  }, [keyword, JSON.stringify(tableSort), currentPage, rowsPerPage, curTypeId]);
  useEffect(function () {
    // set default type to first one
    if (!contextRoot || fetchBillboardTypesRef.current || !_.isEmpty(billboardTypeList)) return;
    fetchBillboardTypesRef.current = true;

    if (_.isEmpty(billboardTypeList)) {
      getBillboardTypeList(contextRoot, false).then(function (result) {
        var newBillboardTypeList = _.map(result.content, function (el) {
          return {
            value: _.trim(el.id),
            text: el.name
          };
        });

        dispatch(setBillboardTypeList(newBillboardTypeList));
      }).catch(function () {
        fetchBillboardTypesRef.current = false;
      });
    }
  }, [contextRoot, billboardTypeList, dispatch]);
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'billboardTypeId', {
    label: t('lbl-billboard-type'),
    sortable: false,
    formatter: function formatter(val, row) {
      var type = _.find(billboardTypeList, function (e) {
        return e.value === val;
      });

      return _.isEmpty(type) ? '' : type.text;
    }
  });

  _.set(fields, 'title', {
    label: t('lbl-title'),
    sortable: true
  });

  _.set(fields, 'description', {
    label: t('lbl-description'),
    sortable: true,
    formatter: function formatter(val, row) {
      if (_.isEmpty(val)) return null;

      var textAry = _.split(val, /\r?\n/g);

      return textAry.length > 1 ? textAry[0] + '...' : val;
    }
  });

  _.set(fields, 'beginTime', {
    label: t('lbl-beginTime'),
    sortable: true
  });

  _.set(fields, 'isShowLive', {
    label: t('lbl-isShowLive'),
    sortable: true,
    formatter: function formatter(val) {
      return /*#__PURE__*/React.createElement(ToggleBtn, {
        disabled: true,
        on: !!val
      });
    }
  });

  _.set(fields, 'more', {
    label: t('lbl-more'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "icon-block"
      }, /*#__PURE__*/React.createElement("a", {
        title: t('lbl-edit'),
        onClick: function onClick() {
          return handleOpenDialog(row);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-list-alt"
      })));
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "billboard-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-billboard-title')), /*#__PURE__*/React.createElement("div", {
    className: "selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-billboard-type'), ": "), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-type-list'),
    list: billboardTypeList,
    value: curTypeId,
    onChange: function onChange(value) {
      setCurTypeId(value);
      setCurrentPage(0);
    },
    width: '200px'
  }))), /*#__PURE__*/React.createElement("div", {
    className: "tooltip-bar"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    searchIconPosition: "right",
    placeholder: "Search",
    onSearch: function onSearch(search) {
      setKeyword(search);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: tableData,
    sort: tableSort,
    onSort: function onSort(sort) {
      return setTableSort(sort);
    }
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: gt('global.lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: function onChangePage(e, newPage) {
      return setCurrentPage(newPage);
    },
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  })), /*#__PURE__*/React.createElement(BillboardViewDetail, {
    detailData: detailData,
    onClose: handleCloseDialog
  }));
};

BillboardView.defaultProps = {
  id: 'g-board-billboard-view'
};
BillboardView.PropTypes = {
  id: PropTypes.string
};
export default BillboardView;